import React, { memo } from "react";
import { ListGroup } from "react-bootstrap";
import "./Preview.scss";
import RenderLatexContent from "../RenderLatexContent";

const renderStatement = (
  data,
  userAnswer,
  updateUserAnswer,
  annotations,
  className,
  isAttempted,
  isCorrectAnswert,
  isTestAttempt
) => {
  return (
    <ListGroup.Item
      className={className ? className : "py-4"}
      style={{ backgroundColor: "transparent" }}
    >
      <RenderLatexContent
        content={data?.statement}
        data={data}
        userAnswer={userAnswer}
        updateUserAnswer={updateUserAnswer}
        isAttempted={isAttempted}
        isCorrectAnswert={isCorrectAnswert}
        isTestAttempt={isTestAttempt}
      />
    </ListGroup.Item>
  );
};

function PreviewStatement({
  data,
  userAnswer = [],
  updateUserAnswer,
  annotations,
  className,
  disableListGroup = false,
  isAttempted = false,
  isTestAttempt = false,
  isCorrectAnswert = false,
}) {
  if (disableListGroup) {
    return (
      <div>
        {renderStatement(
          data,
          userAnswer,
          updateUserAnswer,
          annotations,
          className,
          isAttempted,
          isCorrectAnswert,
          isTestAttempt
        )}
      </div>
    );
  }
  return (
    <ListGroup variant="flush">
      {renderStatement(
        data,
        userAnswer,
        updateUserAnswer,
        annotations,
        className,
        isAttempted,
        isCorrectAnswert,
        isTestAttempt
      )}
    </ListGroup>
  );
}

export default memo(PreviewStatement);
